<script setup lang="ts">
/**
 * RinganPesan — padanan <CaAlert>, hanya menukar <UIcon> dengan SVG inline.
 *
 * Aturannya dibawa utuh: selalu ada ikon + judul + saran tindakan konkret,
 * karena pengguna yang membacanya sedang panik dan butuh tahu HARUS BUAT APA,
 * bukan sekadar "gagal".
 */
const props = withDefaults(
  defineProps<{
    tone?: 'info' | 'ok' | 'warn' | 'bad'
    title?: string
  }>(),
  { tone: 'info' }
)

const petaIkon: Record<string, string> = {
  info: 'info',
  ok: 'circle-check',
  warn: 'triangle-alert',
  bad: 'circle-x'
}
const petaKelas: Record<string, string> = {
  info: 'bg-brand-soft text-ink border-brand/30',
  ok: 'bg-ok-soft text-ink border-ok/35',
  warn: 'bg-warn-soft text-ink border-warn/35',
  bad: 'bg-bad-soft text-ink border-bad/35'
}
const petaIkonWarna: Record<string, string> = {
  info: 'text-brand',
  ok: 'text-ok',
  warn: 'text-warn',
  bad: 'text-bad'
}
const ikon = computed(() => petaIkon[props.tone]!)
</script>

<template>
  <div class="flex gap-3 rounded-control border p-3.5 sm:p-4" :class="petaKelas[tone]" role="status">
    <RinganIkon :nama="ikon" class="size-5 shrink-0 mt-0.5" :class="petaIkonWarna[tone]" />
    <div class="min-w-0 flex-1">
      <p v-if="title" class="font-semibold text-[0.9375rem] leading-snug">{{ title }}</p>
      <div class="text-sm leading-relaxed" :class="title ? 'mt-1 text-muted' : ''">
        <slot />
      </div>
    </div>
  </div>
</template>
